const typographyModalCloneCheckbox = {
  text: 'Clonar Checklist',
  
};

export default typographyModalCloneCheckbox;
